var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#B3B3B3;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25,
    cy: 14.9,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,16.4c0-5.6-4.2-10.1-9.4-10.1s-9.4,4.5-9.4,10.1c0,7.2,9.3,18.7,9.3,18.7S34.4,23.6,34.4,16.4z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "17.1,27.9 10.6,27.9 2.7,42.3 25,42.3 47.3,42.3 39.4,27.9 32.9,27.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.754e8189c8f0ceb862f4f3486a68dd96.svg";
export { ForwardRef as ReactComponent };